// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit';

export interface GeneralState {
  store: any;
}

export const generalStateSlice = createSlice({
  name: 'generalState',
  initialState: <GeneralState>{
    store: {},
  },
  reducers: {
    toggleKey: (state, action) => {
      if (action.payload.key) {
        const currentValue = state.store[action.payload.key];
        state.store[action.payload.key] = !(currentValue === true || currentValue === 'true');
      }
    },
    setKey: (state, action) => {
      if (action.payload.key) state.store[action.payload.key] = action.payload.value;
    },
    deleteKey: (state, action) => {
      if (action.payload.key) delete state.store[action.payload.key];
    },
  },
});

export const { setKey, deleteKey, toggleKey } = generalStateSlice.actions;

export default generalStateSlice.reducer;
